import { EndCustomerService } from 'src/app/services/end-customer.service';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import Swal from 'sweetalert2';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-hospital-details',
  templateUrl: './hospital-details.component.html',
  styleUrls: ['./hospital-details.component.scss']
})
export class HospitalDetailsComponent implements OnInit {

  showImage: boolean = false;
  hospitalData: any;
  specialitiesData: any[] = [];
  servicesData: any[] = [];
  servicesSize: number = 5;
  qrCodeValue: string = '';
  equipmentsData: any[] = [];
  publications: any;
  awards: any;
  associations: any;
  volunteerings: any;
  certifications: any;
  viewMorePublications: any;
  viewMoreAwards: any;
  viewMoreAssociations: any
  viewMoreVolunteerings: any;
  viewMoreCertifications: any;
  viewLessPublications: any;
  viewLessAwards: any;
  viewLessAssociations: any;
  viewLessVolunteerings: any;
  viewLessCertifications: any;
  photos: any;
  showMore: boolean = false;
  viewLess: any;
  viewMore: any;
  infras: any;
  hospitalId!: any;
  hospitalAccountType!: any;
  equipmentImgs: any[] = ['../../assets/images/hospital-equipments.svg', '../../assets/images/hospital-equip1.svg', '../../assets/images/hospital-equip2.svg', '../../assets/images/hospital-equip3.svg'];
  about: string = '';
  @ViewChild('specialityItemsWrapper')
  specialityItemsWrapper!: ElementRef;
  @ViewChild('publicationsList') publicationsList!: ElementRef;
  @ViewChild('awardsList') awardsList!: ElementRef;
  @ViewChild('associationsList') associationsList!: ElementRef;
  @ViewChild('volunteeringsList') volunteeringsList!: ElementRef;
  @ViewChild('certificationsList') certificationsList!: ElementRef;
  length: any;
  awardsLength: any;
  associationsLength: any;
  showMorePublications: boolean = false;
  showMoreAwards: boolean = false;
  showMoreAssociations: boolean = false;
  showMoreVoluteerings: boolean = false;
  showMoreCertifications: boolean = false;
  VolunteeringsLength: any;
  CertificationsLength: any;
  isPublicationsOverflowing = false;
  isAwardsOverflowing = false;
  isAssociationsOverflowing = false;
  isVolunteeringsOverflowing = false;
  isCertificationsOverflowing = false;
  currCarousel: number = 0;
  carouselImgs: any = [];
  viewAll: boolean = false;

  canSlideLeftDoctors = false;
  canSlideRightDoctors = true;
  canSlideLeftEquipments: boolean = false;
  canSlideRightEquipments: boolean = false;
  canSlideLeft: boolean = false;
  canSlideRight: boolean = false;
  canSlideLeftServices: boolean = false;
  canSlideRightServices: boolean = false;
  private scrollListenerAdded = new Set<string>();
  canSlideLeftSpecialities: boolean = false;
  canSlideRightSpecialities: boolean = false;
  containerClass = '';
  isSmallScreen: boolean = false;
  canSlideLeftAcheivements: boolean = false;
  canSlideRightAcheivements: boolean = false; 
  private startX: number = 0;
  private scrollLeft: number = 0;
  private isDown: boolean = false;

  ngAfterViewInit() { 
    setTimeout(() =>
      this.initializeScrolling(), 1000);
  }

  checkOverflow() {
    setTimeout(() => {
     this.isPublicationsOverflowing = this.publicationsList?.nativeElement.scrollHeight > 500;
      this.isAwardsOverflowing = this.awardsList?.nativeElement.scrollHeight > 500;
      this.isAssociationsOverflowing = this.associationsList?.nativeElement.scrollHeight > 500;
      this.isVolunteeringsOverflowing = this.volunteeringsList?.nativeElement.scrollHeight > 500;
      this.isCertificationsOverflowing = this.certificationsList?.nativeElement.scrollHeight > 500;
    }, 0);
  }
  constructor(
    private endCustomerService: EndCustomerService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private spinnerService: SpinnerService,
  ) {
    window.scroll(0, 0)
  }

  ngOnInit(): void {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.route.params.subscribe((res: any) => {
      this.getHospitalDetails(res.id);
    });
    this.slideNxt();
    fromEvent(window, 'resize')
    .subscribe(() => {
      this.checkScreenSize();
      this.initializeScrolling();
    });
  }

  viewMorePublicationsFunc() {
    this.publications = this.hospitalData?.moreInfos[0]?.publications;
    this.showMorePublications = false;
    this.checkOverflow();
  };

  viewMoreAwardsFunc = () => {
    this.awards = this.hospitalData?.moreInfos[0]?.awards;
    this.showMoreAwards = false;
    this.checkOverflow();
  };

  viewMoreAssociationsFunc = () => {
    this.associations = this.hospitalData?.moreInfos[0]?.associations;
    this.showMoreAssociations = false;
    this.checkOverflow();
  };

  viewMoreVolunteeringsFunc = () => {
    this.volunteerings = this.hospitalData?.moreInfos[0]?.volunteerings;
    this.showMoreVoluteerings = false;
    this.checkOverflow();
  };

  viewMoreCertificationsFunc = () => {
    this.certifications = this.hospitalData?.certifications;
    this.showMoreCertifications = false;
    this.checkOverflow();
  };

  viewLessPublicationsFunc = () => {
    this.publications = this.hospitalData?.moreInfos[0]?.publications?.sort((a: { createdOn: string | Date; }, b: { createdOn: string | Date; }) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()).slice(0, 2);
    this.showMorePublications = true;
    this.checkOverflow();
  };

  viewLessAwardsFunc = () => {
    this.awards = this.hospitalData?.moreInfos[0]?.awards?.sort((a: { createdOn: string | Date; }, b: { createdOn: string | Date; }) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()).slice(0, 2);
    this.showMoreAwards = true;
    this.checkOverflow();
  };

  viewLessAssociationsFunc = () => {
    this.associations = this.hospitalData?.moreInfos[0]?.associations?.sort((a: { createdOn: string | Date; }, b: { createdOn: string | Date; }) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()).slice(0, 2);
    this.showMoreAssociations = true;
    this.checkOverflow();
  };

  viewLessVolunteeringsFunc = () => {
    this.volunteerings = this.hospitalData?.moreInfos[0]?.volunteerings?.slice().sort((a: { createdOn: string | Date; }, b: { createdOn: string | Date; }) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()).slice(0, 2);
    this.showMoreVoluteerings = true;
    this.checkOverflow();
  };

  viewLessCertificationsFunc = () => {
    this.certifications = this.hospitalData?.certifications?.sort((a: { createdOn: string | Date; }, b: { createdOn: string | Date; }) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()).slice(0, 2);
    this.showMoreCertifications = true;
    this.checkOverflow();
  };

  splitText(text: string): string[] {
    const words = text.split(' ');
    if (words.length <= 1) {
      return [text];
    }
    const middleIndex = Math.ceil(words.length / 3);
    const firstLine = words.slice(0, middleIndex).join(' ');
    const secondLine = words.slice(middleIndex).join(' ');
    return [firstLine, secondLine];
  }

  carouselChange(point: any) {
    this.currCarousel = this.carouselImgs.indexOf(point);
  }

  slideNxt() {
    setInterval(() => {
      this.carouselChange((this.carouselImgs[this.currCarousel]));
      (this.carouselImgs.length - 1 === this.currCarousel) ? (this.currCarousel = 0) : (this.currCarousel++);
    }, 2000);
  }

  slide(direction: string, containerClass: string) {
    const container = document.querySelector(`.${containerClass}`) as HTMLElement;
    if (!container) return;

    const scrollAmount = container.clientWidth;
    const maxScroll = container.scrollWidth - container.clientWidth;
    const currentScroll = container.scrollLeft;
    let newScrollPosition = currentScroll;

    if (direction === 'left') {
      newScrollPosition = Math.max(0, currentScroll - scrollAmount);
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else if (direction === 'right') {
      newScrollPosition = Math.min(maxScroll, currentScroll + scrollAmount);
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    setTimeout(() => {
      this.updateScrollButtons(containerClass);
    }, 500);

  }

  private updateScrollButtons(containerClass: string) {
    const container = document.querySelector(`.${containerClass}`) as HTMLElement;
    if (!container) return;

    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    this.canSlideLeft = container.scrollLeft > 0;
    this.canSlideRight = container.scrollLeft < maxScrollLeft;
    if (container.scrollWidth > container.clientWidth && container.scrollLeft === 0) {
      this.canSlideRight = true;
    }
    switch (containerClass) {
      case 'hos-doc-container':
        this.canSlideLeftDoctors = this.canSlideLeft;
        this.canSlideRightDoctors = this.canSlideRight;
        break;
      case 'ourAdvanced-container':
        this.canSlideLeftEquipments = this.canSlideLeft;
        this.canSlideRightEquipments = this.canSlideRight;
        break;
      case 'bestServices-container':
        this.canSlideLeftServices = this.canSlideLeft;
        this.canSlideRightServices = this.canSlideRight;
        break;
      case 'specialityContainer':
        this.canSlideLeftSpecialities = this.canSlideLeft;  
        this.canSlideRightSpecialities = this.canSlideRight;
        break;
      case 'contributions':
        this.canSlideLeftAcheivements = this.canSlideLeft;
        this.canSlideRightAcheivements = this.canSlideRight;
        break;
    }    
  }

  initializeScrolling() {
    this.attachScrollListener('hos-doc-container');
    this.attachScrollListener('ourAdvanced-container');
    this.attachScrollListener('bestServices-container');
    this.attachScrollListener('specialityContainer');
    this.attachScrollListener('contributions');
  }

  private attachScrollListener(containerClass: string) {
    const container = document.querySelector(`.${containerClass}`) as HTMLElement;
    if (!container || this.scrollListenerAdded.has(containerClass)) return;
    const checkScrollAvailability = () => {
      if (container.scrollWidth > container.clientWidth) {
        this.updateScrollButtons(containerClass);
        this.scrollListenerAdded.add(containerClass);
        container.addEventListener('scroll', () => {
          this.updateScrollButtons(containerClass);
        }, { passive: true });

        this.setupTouchEvents(containerClass);
      } else {
        setTimeout(checkScrollAvailability, 300);
      }
    };
    checkScrollAvailability();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth >= 320 && window.innerWidth < 1440;
    setTimeout(() => {
      this.updateScrollButtons('hos-doc-container');
      this.updateScrollButtons('ourAdvanced-container');
      this.updateScrollButtons('bestServices-container');
      this.updateScrollButtons('specialityContainer');
      this.updateScrollButtons('contributions');
    }, 500);
  }

  updateSlideCondition() {
    const screenWidth = window.innerWidth;
    const totalCards = this.hospitalData?.members?.length || 0;
    if (screenWidth <= 1536 && screenWidth > 1366) {
      this.containerClass = totalCards <= 4 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.hospitalData?.members?.length > 4;
    } else if (screenWidth <= 1366 && screenWidth > 1024) {
      this.containerClass = totalCards <= 3 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.hospitalData?.members?.length > 3;
    } else if (screenWidth <= 1024) {
      this.containerClass = totalCards <= 2 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.hospitalData?.members?.length > 2;
    } else {
      this.containerClass = totalCards <= 5 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.hospitalData?.members?.length > 5;
    }
  }

  onMouseOver(event: any) {
    this.showImage = false;
  }
 
  getHospitalDetails(id: string) {
    this.endCustomerService.hospitalDetails(id).subscribe((res: any) => {
      this.hospitalData = res.data;
      this.updateSlideCondition();
      this.hospitalId = this.hospitalData?.id;
      this.about = this.hospitalData?.aboutId?.about;
      this.hospitalAccountType = this.hospitalData?.account?.name;

      const moreInfos = this.hospitalData?.moreInfos?.[0] || {};
      const certifications = this.hospitalData?.certifications || [];

      this.publications = moreInfos.publications?.sort((a: { publicationDate: string | Date }, b: { publicationDate: string | Date }) => {
          const dateA = new Date(a.publicationDate);
          const dateB = new Date(b.publicationDate);
          const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
          const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
          return timeB - timeA; 
      }) || [];

      this.awards = moreInfos.awards?.sort((a: { awardDate: string | Date }, b: { awardDate: string | Date }) => {
          const dateA = new Date(a.awardDate);
          const dateB = new Date(b.awardDate);
          const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
          const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
          return timeB - timeA;
      }) || [];

      this.associations = moreInfos.associations?.sort((a: { fromDate: string | Date }, b: { fromDate: string | Date }) => {
          const dateA = new Date(a.fromDate);
          const dateB = new Date(b.fromDate);
          const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
          const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
          return timeB - timeA;
      }) || [];

      this.volunteerings = moreInfos.volunteerings?.sort((a: { fromDate: string | Date }, b: { fromDate: string | Date }) => {
          const dateA = new Date(a.fromDate);
          const dateB = new Date(b.fromDate);
          const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
          const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
          return timeB - timeA;
      }) || [];

     
       this.certifications = certifications.sort((a: { year?: number | string }, b: { year?: number | string }) => {
        const yearA = Number(a.year) || 0; 
        const yearB = Number(b.year) || 0;
        return yearB - yearA; 
    }) || [];

      this.length = moreInfos.publications?.length || 0;
      this.awardsLength = moreInfos.awards?.length || 0;
      this.associationsLength = moreInfos.associations?.length || 0;
      this.VolunteeringsLength = moreInfos.volunteerings?.length || 0;
      this.CertificationsLength = certifications.length || 0;

      this.showMorePublications = this.length > 2;
      this.showMoreAwards = this.awardsLength > 2;
      this.showMoreAssociations = this.associationsLength > 2;
      this.showMoreVoluteerings = this.VolunteeringsLength > 2;
      this.showMoreCertifications = this.CertificationsLength > 2;

    
      this.viewMorePublications = () => {
          this.publications = moreInfos.publications?.sort((a: { publicationDate: string | Date }, b: { publicationDate: string | Date }) => {
              const dateA = new Date(a.publicationDate);
              const dateB = new Date(b.publicationDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          }) || [];
          this.showMorePublications = false;
          this.checkOverflow();
      };

      this.viewMoreAwards = () => {
          this.awards = moreInfos.awards?.sort((a: { awardDate: string | Date }, b: { awardDate: string | Date }) => {
              const dateA = new Date(a.awardDate);
              const dateB = new Date(b.awardDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          }) || [];
          this.showMoreAwards = false;
          this.checkOverflow();
      };

      this.viewMoreAssociations = () => {
          this.associations = moreInfos.associations?.sort((a: { fromDate: string | Date }, b: { fromDate: string | Date }) => {
              const dateA = new Date(a.fromDate);
              const dateB = new Date(b.fromDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          }) || [];
          this.showMoreAssociations = false;
          this.checkOverflow();
      };

      this.viewMoreVolunteerings = () => {
          this.volunteerings = moreInfos.volunteerings?.sort((a: { fromDate: string | Date }, b: { fromDate: string | Date }) => {
              const dateA = new Date(a.fromDate);
              const dateB = new Date(b.fromDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          }) || [];
          this.showMoreVoluteerings = false;
          this.checkOverflow();
      };

      this.viewMoreCertifications = () => {
          this.certifications = certifications.sort((a: { createdOn: string | Date }, b: { createdOn: string | Date }) => {
              const dateA = new Date(a.createdOn);
              const dateB = new Date(b.createdOn);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          }) || [];
          this.showMoreCertifications = false;
          this.checkOverflow();
      };

      this.viewLessPublications = () => {
          this.publications = moreInfos.publications?.sort((a: { publicationDate: string | Date }, b: { publicationDate: string | Date }) => {
              const dateA = new Date(a.publicationDate);
              const dateB = new Date(b.publicationDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          })?.slice(0, 2) || []; 
          this.showMorePublications = true;
          this.checkOverflow();
      };

      this.viewLessAwards = () => {
          this.awards = moreInfos.awards?.sort((a: { awardDate: string | Date }, b: { awardDate: string | Date }) => {
              const dateA = new Date(a.awardDate);
              const dateB = new Date(b.awardDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          })?.slice(0, 2) || [];
          this.showMoreAwards = true;
          this.checkOverflow();
      };

      this.viewLessAssociations = () => {
          this.associations = moreInfos.associations?.sort((a: { fromDate: string | Date }, b: { fromDate: string | Date }) => {
              const dateA = new Date(a.fromDate);
              const dateB = new Date(b.fromDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          })?.slice(0, 2) || [];
          this.showMoreAssociations = true;
          this.checkOverflow();
      };

      this.viewLessVolunteerings = () => {
          this.volunteerings = moreInfos.volunteerings?.sort((a: { fromDate: string | Date }, b: { fromDate: string | Date }) => {
              const dateA = new Date(a.fromDate);
              const dateB = new Date(b.fromDate);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          })?.slice(0, 2) || [];
          this.showMoreVoluteerings = true;
          this.checkOverflow();
      };

      this.viewLessCertifications = () => {
          this.certifications = certifications.sort((a: { createdOn: string | Date }, b: { createdOn: string | Date }) => {
              const dateA = new Date(a.createdOn);
              const dateB = new Date(b.createdOn);
              const timeA = isNaN(dateA.getTime()) ? new Date(0).getTime() : dateA.getTime();
              const timeB = isNaN(dateB.getTime()) ? new Date(0).getTime() : dateB.getTime();
              return timeB - timeA;
          })?.slice(0, 2) || [];
          this.showMoreCertifications = true;
          this.checkOverflow();
      };

      this.checkOverflow();

      this.photos = this.hospitalData?.photos;
      if (this.photos?.length) {
        this.photos = this.photos.sort((a: { createdOn: string | Date }, b: { createdOn: string | Date }) => 
            new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
        ).slice(0, 6);
      }
      this.infras = this.hospitalData?.infras[0];
      this.getSpecialities();
      this.getEquipments();
      this.hospitalData.carouselImages.forEach((caro: any) => {
        this.carouselImgs.push(caro.carouselImages);
      });
      this.getServices();
      if (this.hospitalData?.qrCodeURL === undefined) {
        this.spinnerService.showSpinner();
        this.generateQRCode();
        this.spinnerService.hideSpinner();
      }
    }, (error: any) => {
      console.error('Failed to fetch hospital details:', error);
      this.publications = [];
      this.awards = [];
      this.associations = [];
      this.volunteerings = [];
      this.certifications = [];
      this.photos = [];
      this.infras = {};
      this.carouselImgs = [];
      this.checkOverflow();
    });
}

  getSpecialities() {
    this.endCustomerService.specialities().subscribe((res: any) => {
      let lst: any[] = [];
      const specialities: any[] = [];
      this.hospitalData.specialityInfos.forEach((s: any) => {
        lst.push(s.specialityInfoId);
      })
      res.data.forEach((data: any) => {
        if (lst.includes(data.id) && lst?.length !== 0) {
          specialities.push([data.name, data.imageUrl]);
        }
      })
      this.specialitiesData = specialities;
    });
  }

  getEquipments() {
    this.endCustomerService.equipments().subscribe((res: any) => {
      let lst: any[] = [];
      const equipments: any[] = [];
      if (this.hospitalData?.equipments.length !== 0) {
        this.hospitalData.equipments.forEach((e: any) => {
          lst.push(e.equipmentInfoId);
        })
        res.data.forEach((data: any) => {
          if (lst.includes(data.id) && lst?.length !== 0) {
            equipments.push(data);
          }
        })
      }
      this.equipmentsData = equipments;
    });
  }

  getServices() {
    this.endCustomerService.services().subscribe((res: any) => {
      this.hospitalData?.serviceInfos.map((s: any) => {
        res.data.map((data: any) => {
          if (s.serviceInfoId === data.id) {
            this.servicesData.push([data.name, data.imageUrl]);
          }
        })
      })
      this.spinnerService.hideSpinner();
    });
  }

  viewAllServices() {
    if (this.viewAll) {
      const topOfPage = document.querySelector('.portfolio');
      if (topOfPage) {
        topOfPage.scrollIntoView();
      }
      this.viewAll = false;
      this.servicesSize = 5;
    }
    else {
      this.viewAll = true;
      this.servicesSize = this.servicesData.length;
    }
  }

  socialNavigations(type: string) {
    switch (type) {
      case 'fb':
        let urlf = this.hospitalData?.aboutId?.facebookUrl;
        if (urlf === '' || urlf === null || urlf === undefined) {
          this.openSwal();
        } else {
          if (!urlf.startsWith('http://') && !urlf.startsWith('https://')) {
            urlf = 'https://' + urlf;
          }
          window.open(urlf, '_blank');
        }
        break;
      case 'insta':
        let urli = this.hospitalData?.aboutId?.instagramUrl;
        if (urli === '' || urli === null || urli === undefined) {
          this.openSwal();
        } else {
          if (!urli.startsWith('http://') && !urli.startsWith('https://')) {
            urli = 'https://' + urli;
          }
          window.open(urli, '_blank');
        }
        break;
      case 'linkedin':
        let urll = this.hospitalData?.aboutId?.linkedin;
        if (urll === '' || urll === null || urll === undefined) {
          this.openSwal();
        } else {
          if (!urll.startsWith('http://') && !urll.startsWith('https://')) {
            urll = 'https://' + urll;
          }
          window.open(urll, '_blank');
        }
        break;
      case 'x':
        let urlx = this.hospitalData?.aboutId?.twitterUrl;
        if (urlx === '' || urlx === null || urlx === undefined) {
          this.openSwal();
        } else {
          if (!urlx.startsWith('http://') && !urlx.startsWith('https://')) {
            urlx = 'https://' + urlx;
          }
          window.open(urlx, '_blank');
        }
        break;
      default:
        break;
    }

  }
  generateQRCode() {
    const data = {
      id: this.hospitalId,
      accountType: this.hospitalAccountType.trim()
    }
    this.endCustomerService.generateQRCode(data).subscribe((res: any) => {
      this.hospitalData.qrCodeURL = res;
    })
  }

  onMouseOut(event: any) {
    this.showImage = true;
  }

  openDialPad(phoneCode: any, phoneNumber: any) {
    let dialPadLink = '';
    if (phoneNumber === '' || phoneNumber === null || phoneNumber === undefined) {
      return;
    }
    if (phoneCode === '' || phoneCode === null || phoneCode === undefined) {
      dialPadLink = `tel:${phoneNumber}`;
    } else {
      dialPadLink = `tel:${phoneCode}${phoneNumber}`;
    }
    window.open(dialPadLink);
  }
  openWebsite(url: any) {
    if (url === '' || url === null || url === undefined) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank');
  }

  openSwal() {
    Swal.fire({
      position: 'center',
      title: '',
      width: '300px',
      text: 'To Be Updated Soon',
      iconHtml: '<img src="./assets/images/group-delete.svg">',
      iconColor: 'white',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#0f74a9',
      backdrop: false,
      didOpen: () => {
        window.removeEventListener('resize', () => { });
        document.body.style.overflow = "hidden";
      },
      didClose: () => {
        document.body.style.overflow = "scroll";
        window.addEventListener('resize', () => { });
      }
    })
  }

  getInitial(name: string): string {
    if (!name) return '';
    const cleanedName = name.replace(/^Dr\.?\s+/, '');
    return cleanedName.charAt(0).toUpperCase();
  }
  private setupTouchEvents(containerClass: string) {
    const container = document.querySelector(`.${containerClass}`) as HTMLElement;
    if (!container) return;
    
    // Touch events for mobile/tablet
    container.addEventListener('touchstart', (e: TouchEvent) => {
      this.isDown = true;
      this.startX = e.touches[0].pageX - container.offsetLeft;
      this.scrollLeft = container.scrollLeft;
      container.style.scrollBehavior = 'auto'; // Disable smooth scrolling during touch
    }, { passive: true });
    
    container.addEventListener('touchend', () => {
      this.isDown = false;
      container.style.scrollBehavior = 'smooth'; // Re-enable smooth scrolling
      this.updateScrollButtons(containerClass);
    }, { passive: true });
    
    container.addEventListener('touchmove', (e: TouchEvent) => {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.touches[0].pageX - container.offsetLeft;
      const walk = (x - this.startX) * 2; // Scroll speed multiplier
      container.scrollLeft = this.scrollLeft - walk;
      this.updateScrollButtons(containerClass);
    }, { passive: false });
  }
}
